(function () {
  document.querySelectorAll('.lg-brand-grid').forEach(function (root) {
    var sectionId = root.dataset.sectionId;
    var showImage = root.dataset.showImage === 'true';
    var showName = root.dataset.showName !== 'false';
    var varName = 'lgBrandsData_' + sectionId.replace(/-/g, '_');
    var paginationVarName = 'lgBrandsPagination_' + sectionId.replace(/-/g, '_');
    var pagination = window[paginationVarName];
    var totalPages = pagination ? pagination.totalPages : 1;
    var currentPage = pagination ? pagination.currentPage : 1;

    var indexContainer = root.querySelector('.lg-brand-grid__index');
    var gridContainer = root.querySelector('.lg-brand-grid__grid');

    function groupByInitial(arr) {
      var groups = {};
      arr.forEach(function (item) {
        var firstChar = item.title.charAt(0).toUpperCase();
        var category = /[A-Z]/.test(firstChar) ? firstChar : '0-9';
        if (!groups[category]) groups[category] = [];
        groups[category].push(item);
      });
      return groups;
    }

    function renderIndex(groups) {
      indexContainer.innerHTML = '';
      var keys = Object.keys(groups).sort();
      keys.forEach(function (letter, index) {
        var span = document.createElement('span');
        span.classList.add('lg-brand-grid__filter');
        span.textContent = letter;
        span.addEventListener('click', function () { scrollToLetter(letter, span); });
        indexContainer.appendChild(span);

        if (index < keys.length - 1) {
          var s = document.createElement('span');
          s.classList.add('lg-brand-grid__separator');
          s.textContent = ' / ';
          indexContainer.appendChild(s);
        }
      });
    }

    function renderGroups(groups) {
      gridContainer.innerHTML = '';

      Object.keys(groups).sort().forEach(function (letter) {
        var section = document.createElement('div');
        section.classList.add('lg-brand-grid__group');
        section.id = 'group-' + sectionId + '-' + letter;

        var header = document.createElement('h4');
        header.textContent = letter;
        section.appendChild(header);

        var itemsDiv = document.createElement('div');

        groups[letter].forEach(function (item) {
          var link = document.createElement('a');
          link.classList.add('lg-brand-grid__item');
          link.href = item.url;

          var imageRendered = false;
          var fallbackRendered = false;

          if (showImage) {
            if (item.image) {
              var img = document.createElement('img');
              img.classList.add('lg-brand-grid__image');
              img.src = item.image;
              img.alt = item.title;
              img.loading = 'lazy';
              link.appendChild(img);
              imageRendered = true;
            } else {
              var fallback = document.createElement('span');
              fallback.classList.add('lg-brand-grid__image-fallback');
              fallback.textContent = item.title;
              link.appendChild(fallback);
              fallbackRendered = true;
            }
          }

          if (showName && !fallbackRendered) {
            var name = document.createElement('span');
            name.classList.add('lg-brand-grid__name');
            name.textContent = item.title;
            link.appendChild(name);
          } else if (!showName && imageRendered) {
            var srOnly = document.createElement('span');
            srOnly.classList.add('visually-hidden');
            srOnly.textContent = item.title;
            link.appendChild(srOnly);
          }

          itemsDiv.appendChild(link);
        });

        section.appendChild(itemsDiv);
        gridContainer.appendChild(section);
      });
    }

    function setActive(button) {
      root.querySelectorAll('.lg-brand-grid__filter').forEach(function (btn) {
        btn.classList.remove('active');
      });
      button.classList.add('active');
    }

    function scrollToLetter(letter, button) {
      setActive(button);
      var target = document.getElementById('group-' + sectionId + '-' + letter);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function render() {
      var brands = window[varName] || [];
      if (!brands.length) return;
      var grouped = groupByInitial(brands);
      renderIndex(grouped);
      renderGroups(grouped);
    }

    function executeDataScripts(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach(function (s) {
        if (s.textContent.indexOf(varName) === -1) return;
        var script = document.createElement('script');
        script.textContent = s.textContent;
        document.head.appendChild(script);
        document.head.removeChild(script);
      });
    }

    function fetchAdditionalPages() {
      if (totalPages <= currentPage) return Promise.resolve();
      var promises = [];
      for (var p = currentPage + 1; p <= totalPages; p++) {
        promises.push(
          fetch(window.location.pathname + '?page=' + p + '&sections=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.json(); })
            .then(function (json) {
              var html = json[sectionId];
              if (html) executeDataScripts(html);
            })
        );
      }
      return Promise.all(promises);
    }

    render();

    fetchAdditionalPages().then(render).catch(function (e) {
      console.warn('lg-brands: error loading additional pages', e);
    });
  });
})();
